const theme = {
  token: {
    colorPrimary: "#60b565",
    borderRadius: 6,
    colorLink: "#60b565",
    colorLinkHover: "#6cc371",
    colorLinkActive: "#4c8250",
    controlHeightLG: 42,
    fontSize: 16,
  },
  components: {
    Layout: {
      // colorBgHeader: "#1b3f26a6",
      colorBgHeader: "transparent",
      paddingHeader: "0 30px",
    },
  },
};

export { theme };
